import React, { useState } from 'react';
import ArtemisCompleteWorkflow from './ArtemisCompleteWorkflow';
import ArtemisSimpleJourney from './ArtemisSimpleJourney';
import ArtemisEvolution_SingleCode from './ArtemisEvolution_SingleCode';
import ArtemisEvolution_Repository from './ArtemisEvolution_Repository';
import ArtemisEvolution_MultiFile from './ArtemisEvolution_MultiFile';
import ArtemisGeneration_Applications from './ArtemisGeneration_Applications';
import ArtemisGeneration_Tests from './ArtemisGeneration_Tests';
import ArtemisGeneration_Benchmarks from './ArtemisGeneration_Benchmarks';
import ArtemisAutomation_Research from './ArtemisAutomation_Research';
import ArtemisEvolution_Agents from './ArtemisEvolution_Agents';
import ArtemisOptimization_CodeRefactoring from './ArtemisOptimization_CodeRefactoring';
import ArtemisOptimization_SecurityHardening from './ArtemisOptimization_SecurityHardening';
import ArtemisOptimization_ApiPerformance from './ArtemisOptimization_ApiPerformance';
import ArtemisOptimization_MemoryManagement from './ArtemisOptimization_MemoryManagement';
import ArtemisInfo from './ArtemisInfo';


const ArtemisUniqueness = () => {
  const [selectedDiagram, setSelectedDiagram] = useState('workflow');
  const [isMenuOpen, setIsMenuOpen] = useState(true); // Changed to true to keep menu open by default

  const diagramComponents = {
    info: ArtemisInfo,
    workflow: ArtemisCompleteWorkflow,
    simpleJourney: ArtemisSimpleJourney,
    singleCode: ArtemisEvolution_SingleCode,
    repository: ArtemisEvolution_Repository,
    multiFile: ArtemisEvolution_MultiFile,
    appBuilder: ArtemisGeneration_Applications,
    testGeneration: ArtemisGeneration_Tests,
    benchmarkGeneration: ArtemisGeneration_Benchmarks,
    autoResearcher: ArtemisAutomation_Research,
    agentsEvolution: ArtemisEvolution_Agents,
    codeRefactoring: ArtemisOptimization_CodeRefactoring,
    securityHardening: ArtemisOptimization_SecurityHardening,
    apiOptimization: ArtemisOptimization_ApiPerformance,
    memoryOptimization: ArtemisOptimization_MemoryManagement
  };

  const DiagramComponent = diagramComponents[selectedDiagram];

  return (
    <div style={{ 
      height: '100vh', 
      width: '100%', 
      position: 'relative',
      display: 'flex'
    }}>
      {/* Main Diagram Area */}
      <div style={{ 
        flex: 1,
        position: 'relative'
      }}>
        <DiagramComponent />
        
        {/* Compact Diagram Selector - Top Left */}
        <div style={{
          position: 'absolute',
          top: '80px',
          left: '20px',
          zIndex: 100
        }}>
          {/* Collapsed Menu Button */}
          {!isMenuOpen && (
            <button
              onClick={() => setIsMenuOpen(true)}
              style={{
                padding: '10px 20px',
                background: 'rgba(255, 255, 255, 0.95)',
                border: '1px solid rgba(0, 0, 0, 0.1)',
                borderRadius: '25px',
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: '600',
                fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                transition: 'all 0.2s ease'
              }}
            >
              <span>📋</span>
              {selectedDiagram === 'info' && 'Why Artemis?'}
              {selectedDiagram === 'workflow' && 'Complete Workflow'}
              {selectedDiagram === 'simpleJourney' && 'Simple Journey'}
              {selectedDiagram === 'agentsEvolution' && 'Agents Evolution'}
              {selectedDiagram === 'singleCode' && 'Single Code Evolution'}
              {selectedDiagram === 'repository' && 'Repository Evolution'}
              {selectedDiagram === 'multiFile' && 'Multi-File Evolution'}
              {selectedDiagram === 'testGeneration' && 'Test Generation'}
              {selectedDiagram === 'benchmarkGeneration' && 'Benchmark Generation'}
              {selectedDiagram === 'appBuilder' && 'App Builder'}
              {selectedDiagram === 'autoResearcher' && 'Auto Researcher'}
              {selectedDiagram === 'codeRefactoring' && 'Code Refactoring'}
              {selectedDiagram === 'securityHardening' && 'Security Hardening'}
              {selectedDiagram === 'apiOptimization' && 'API Optimization'}
              {selectedDiagram === 'memoryOptimization' && 'Memory Optimization'}
              <span style={{ fontSize: '10px' }}>▼</span>
            </button>
          )}

          {/* Expanded Menu */}
          {isMenuOpen && (
            <div style={{
              background: 'rgba(255, 255, 255, 0.98)',
              borderRadius: '15px',
              padding: '15px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
              border: '1px solid rgba(0, 0, 0, 0.05)',
              maxWidth: '350px',
              backdropFilter: 'blur(10px)'
            }}>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '12px'
              }}>
                <div style={{
                  fontSize: '12px',
                  fontWeight: '600',
                  color: '#495057',
                  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px'
                }}>
                  Select Diagram
                </div>
                <button
                  onClick={() => setIsMenuOpen(false)}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '18px',
                    color: '#6C757D',
                    padding: '0',
                    width: '24px',
                    height: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    transition: 'background 0.2s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.background = '#F8F9FA'}
                  onMouseLeave={(e) => e.target.style.background = 'none'}
                >
                  ✕
                </button>
              </div>
              
              {/* Info Button */}
              <div style={{ marginBottom: '15px' }}>
                <button
                  onClick={() => {
                    setSelectedDiagram('info');
                    setIsMenuOpen(false);
                  }}
                  style={{
                    padding: '12px 20px',
                    background: selectedDiagram === 'info' ? 
                      'linear-gradient(135deg, #F4511E 0%, #FF6D00 100%)' : 
                      '#F8F9FA',
                    color: selectedDiagram === 'info' ? 'white' : '#495057',
                    border: selectedDiagram === 'info' ? 'none' : '1px solid #DEE2E6',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '600',
                    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                    transition: 'all 0.2s ease',
                    boxShadow: selectedDiagram === 'info' ? '0 2px 8px rgba(244, 81, 30, 0.3)' : 'none',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px'
                  }}
                >
                  <span>🚀</span>
                  Why Artemis?
                </button>
              </div>
              
              {/* Core Workflows */}
              <div style={{ marginBottom: '15px' }}>
                <div style={{
                  fontSize: '11px',
                  color: '#6C757D',
                  marginBottom: '8px',
                  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif'
                }}>
                  Core Workflows
                </div>
                <div style={{
                  display: 'flex',
                  gap: '8px',
                  flexWrap: 'wrap'
                }}>
                  <button
                    onClick={() => {
                      setSelectedDiagram('workflow');
                      setIsMenuOpen(false);
                    }}
                    style={{
                      padding: '8px 16px',
                      background: selectedDiagram === 'workflow' ? 
                        'linear-gradient(135deg, #F4511E 0%, #FF6D00 100%)' : 
                        '#F8F9FA',
                      color: selectedDiagram === 'workflow' ? 'white' : '#495057',
                      border: selectedDiagram === 'workflow' ? 'none' : '1px solid #DEE2E6',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '500',
                      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                      transition: 'all 0.2s ease',
                      boxShadow: selectedDiagram === 'workflow' ? '0 2px 8px rgba(244, 81, 30, 0.3)' : 'none'
                    }}
                  >
                    📋 Complete Workflow
                  </button>
                  <button
                    onClick={() => {
                      setSelectedDiagram('simpleJourney');
                      setIsMenuOpen(false);
                    }}
                    style={{
                      padding: '8px 16px',
                      background: selectedDiagram === 'simpleJourney' ? 
                        'linear-gradient(135deg, #F4511E 0%, #FF6D00 100%)' : 
                        '#F8F9FA',
                      color: selectedDiagram === 'simpleJourney' ? 'white' : '#495057',
                      border: selectedDiagram === 'simpleJourney' ? 'none' : '1px solid #DEE2E6',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '500',
                      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                      transition: 'all 0.2s ease',
                      boxShadow: selectedDiagram === 'simpleJourney' ? '0 2px 8px rgba(244, 81, 30, 0.3)' : 'none'
                    }}
                  >
                    ✨ Simple Journey
                  </button>
                  <button
                    onClick={() => {
                      setSelectedDiagram('agentsEvolution');
                      setIsMenuOpen(false);
                    }}
                    style={{
                      padding: '8px 16px',
                      background: selectedDiagram === 'agentsEvolution' ? 
                        'linear-gradient(135deg, #F4511E 0%, #FF6D00 100%)' : 
                        '#F8F9FA',
                      color: selectedDiagram === 'agentsEvolution' ? 'white' : '#495057',
                      border: selectedDiagram === 'agentsEvolution' ? 'none' : '1px solid #DEE2E6',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '500',
                      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                      transition: 'all 0.2s ease',
                      boxShadow: selectedDiagram === 'agentsEvolution' ? '0 2px 8px rgba(244, 81, 30, 0.3)' : 'none'
                    }}
                  >
                    🤖 Agents Evolution
                  </button>
                </div>
              </div>

              {/* Evolution Processes */}
              <div style={{ marginBottom: '15px' }}>
                <div style={{
                  fontSize: '11px',
                  color: '#6C757D',
                  marginBottom: '8px',
                  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif'
                }}>
                  Evolution Processes
                </div>
                <div style={{
                  display: 'flex',
                  gap: '8px',
                  flexWrap: 'wrap'
                }}>
                  <button
                    onClick={() => {
                      setSelectedDiagram('singleCode');
                      setIsMenuOpen(false);
                    }}
                    style={{
                      padding: '8px 16px',
                      background: selectedDiagram === 'singleCode' ? 
                        'linear-gradient(135deg, #F4511E 0%, #FF6D00 100%)' : 
                        '#F8F9FA',
                      color: selectedDiagram === 'singleCode' ? 'white' : '#495057',
                      border: selectedDiagram === 'singleCode' ? 'none' : '1px solid #DEE2E6',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '500',
                      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                      transition: 'all 0.2s ease',
                      boxShadow: selectedDiagram === 'singleCode' ? '0 2px 8px rgba(244, 81, 30, 0.3)' : 'none'
                    }}
                  >
                    🧬 Single Code
                  </button>
                  <button
                    onClick={() => {
                      setSelectedDiagram('repository');
                      setIsMenuOpen(false);
                    }}
                    style={{
                      padding: '8px 16px',
                      background: selectedDiagram === 'repository' ? 
                        'linear-gradient(135deg, #F4511E 0%, #FF6D00 100%)' : 
                        '#F8F9FA',
                      color: selectedDiagram === 'repository' ? 'white' : '#495057',
                      border: selectedDiagram === 'repository' ? 'none' : '1px solid #DEE2E6',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '500',
                      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                      transition: 'all 0.2s ease',
                      boxShadow: selectedDiagram === 'repository' ? '0 2px 8px rgba(244, 81, 30, 0.3)' : 'none'
                    }}
                  >
                    🗂️ Repository
                  </button>
                  <button
                    onClick={() => {
                      setSelectedDiagram('multiFile');
                      setIsMenuOpen(false);
                    }}
                    style={{
                      padding: '8px 16px',
                      background: selectedDiagram === 'multiFile' ? 
                        'linear-gradient(135deg, #F4511E 0%, #FF6D00 100%)' : 
                        '#F8F9FA',
                      color: selectedDiagram === 'multiFile' ? 'white' : '#495057',
                      border: selectedDiagram === 'multiFile' ? 'none' : '1px solid #DEE2E6',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '500',
                      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                      transition: 'all 0.2s ease',
                      boxShadow: selectedDiagram === 'multiFile' ? '0 2px 8px rgba(244, 81, 30, 0.3)' : 'none'
                    }}
                  >
                    🚀 Multi-File
                  </button>
                </div>
              </div>

              {/* Use Cases */}
              <div>
                <div style={{
                  fontSize: '11px',
                  color: '#6C757D',
                  marginBottom: '8px',
                  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif'
                }}>
                  Use Cases
                </div>
                <div style={{
                  display: 'flex',
                  gap: '8px',
                  flexWrap: 'wrap'
                }}>
                  <button
                    onClick={() => {
                      setSelectedDiagram('testGeneration');
                      setIsMenuOpen(false);
                    }}
                    style={{
                      padding: '8px 16px',
                      background: selectedDiagram === 'testGeneration' ? 
                        'linear-gradient(135deg, #F4511E 0%, #FF6D00 100%)' : 
                        '#F8F9FA',
                      color: selectedDiagram === 'testGeneration' ? 'white' : '#495057',
                      border: selectedDiagram === 'testGeneration' ? 'none' : '1px solid #DEE2E6',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '500',
                      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                      transition: 'all 0.2s ease',
                      boxShadow: selectedDiagram === 'testGeneration' ? '0 2px 8px rgba(244, 81, 30, 0.3)' : 'none'
                    }}
                  >
                    🧪 Test Generation
                  </button>
                  <button
                    onClick={() => {
                      setSelectedDiagram('benchmarkGeneration');
                      setIsMenuOpen(false);
                    }}
                    style={{
                      padding: '8px 16px',
                      background: selectedDiagram === 'benchmarkGeneration' ? 
                        'linear-gradient(135deg, #F4511E 0%, #FF6D00 100%)' : 
                        '#F8F9FA',
                      color: selectedDiagram === 'benchmarkGeneration' ? 'white' : '#495057',
                      border: selectedDiagram === 'benchmarkGeneration' ? 'none' : '1px solid #DEE2E6',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '500',
                      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                      transition: 'all 0.2s ease',
                      boxShadow: selectedDiagram === 'benchmarkGeneration' ? '0 2px 8px rgba(244, 81, 30, 0.3)' : 'none'
                    }}
                  >
                    📊 Benchmarks
                  </button>
                  <button
                    onClick={() => {
                      setSelectedDiagram('appBuilder');
                      setIsMenuOpen(false);
                    }}
                    style={{
                      padding: '8px 16px',
                      background: selectedDiagram === 'appBuilder' ? 
                        'linear-gradient(135deg, #F4511E 0%, #FF6D00 100%)' : 
                        '#F8F9FA',
                      color: selectedDiagram === 'appBuilder' ? 'white' : '#495057',
                      border: selectedDiagram === 'appBuilder' ? 'none' : '1px solid #DEE2E6',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '500',
                      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                      transition: 'all 0.2s ease',
                      boxShadow: selectedDiagram === 'appBuilder' ? '0 2px 8px rgba(244, 81, 30, 0.3)' : 'none'
                    }}
                  >
                    🏗️ App Builder
                  </button>
                  <button
                    onClick={() => {
                      setSelectedDiagram('autoResearcher');
                      setIsMenuOpen(false);
                    }}
                    style={{
                      padding: '8px 16px',
                      background: selectedDiagram === 'autoResearcher' ? 
                        'linear-gradient(135deg, #F4511E 0%, #FF6D00 100%)' : 
                        '#F8F9FA',
                      color: selectedDiagram === 'autoResearcher' ? 'white' : '#495057',
                      border: selectedDiagram === 'autoResearcher' ? 'none' : '1px solid #DEE2E6',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '500',
                      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                      transition: 'all 0.2s ease',
                      boxShadow: selectedDiagram === 'autoResearcher' ? '0 2px 8px rgba(244, 81, 30, 0.3)' : 'none'
                    }}
                  >
                    🔬 Auto Researcher
                  </button>
                  <button
                    onClick={() => {
                      setSelectedDiagram('codeRefactoring');
                      setIsMenuOpen(false);
                    }}
                    style={{
                      padding: '8px 16px',
                      background: selectedDiagram === 'codeRefactoring' ? 
                        'linear-gradient(135deg, #F4511E 0%, #FF6D00 100%)' : 
                        '#F8F9FA',
                      color: selectedDiagram === 'codeRefactoring' ? 'white' : '#495057',
                      border: selectedDiagram === 'codeRefactoring' ? 'none' : '1px solid #DEE2E6',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '500',
                      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                      transition: 'all 0.2s ease',
                      boxShadow: selectedDiagram === 'codeRefactoring' ? '0 2px 8px rgba(244, 81, 30, 0.3)' : 'none'
                    }}
                  >
                    🔧 Code Refactoring
                  </button>
                  <button
                    onClick={() => {
                      setSelectedDiagram('securityHardening');
                      setIsMenuOpen(false);
                    }}
                    style={{
                      padding: '8px 16px',
                      background: selectedDiagram === 'securityHardening' ? 
                        'linear-gradient(135deg, #F4511E 0%, #FF6D00 100%)' : 
                        '#F8F9FA',
                      color: selectedDiagram === 'securityHardening' ? 'white' : '#495057',
                      border: selectedDiagram === 'securityHardening' ? 'none' : '1px solid #DEE2E6',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '500',
                      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                      transition: 'all 0.2s ease',
                      boxShadow: selectedDiagram === 'securityHardening' ? '0 2px 8px rgba(244, 81, 30, 0.3)' : 'none'
                    }}
                  >
                    🔒 Security Hardening
                  </button>
                  <button
                    onClick={() => {
                      setSelectedDiagram('apiOptimization');
                      setIsMenuOpen(false);
                    }}
                    style={{
                      padding: '8px 16px',
                      background: selectedDiagram === 'apiOptimization' ? 
                        'linear-gradient(135deg, #F4511E 0%, #FF6D00 100%)' : 
                        '#F8F9FA',
                      color: selectedDiagram === 'apiOptimization' ? 'white' : '#495057',
                      border: selectedDiagram === 'apiOptimization' ? 'none' : '1px solid #DEE2E6',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '500',
                      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                      transition: 'all 0.2s ease',
                      boxShadow: selectedDiagram === 'apiOptimization' ? '0 2px 8px rgba(244, 81, 30, 0.3)' : 'none'
                    }}
                  >
                    ⚡ API Optimization
                  </button>
                  <button
                    onClick={() => {
                      setSelectedDiagram('memoryOptimization');
                      setIsMenuOpen(false);
                    }}
                    style={{
                      padding: '8px 16px',
                      background: selectedDiagram === 'memoryOptimization' ? 
                        'linear-gradient(135deg, #F4511E 0%, #FF6D00 100%)' : 
                        '#F8F9FA',
                      color: selectedDiagram === 'memoryOptimization' ? 'white' : '#495057',
                      border: selectedDiagram === 'memoryOptimization' ? 'none' : '1px solid #DEE2E6',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '500',
                      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                      transition: 'all 0.2s ease',
                      boxShadow: selectedDiagram === 'memoryOptimization' ? '0 2px 8px rgba(244, 81, 30, 0.3)' : 'none'
                    }}
                  >
                    💾 Memory Optimization
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default ArtemisUniqueness; 